import styled from "styled-components";

export const Column = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;
